/**
 * Interview chat GraphQL helpers.
 *
 * Only two things come from fs-backend: the population-wide adoption summary, and the
 * interview a selected chat is anchored to. The channel list and the messages come from
 * GetStream via ./stream.ts, so nothing here grows with the number of chats.
 *
 * JWT flows through the app Apollo client's authLink (configured in App.tsx).
 */
import { ApolloClient } from '@apollo/client';
import { GET_INTERVIEW_CHAT_SUMMARY, GET_INTERVIEW_FOR_CHAT } from './queries';
import { InterviewChatInterview, InterviewChatSummary } from './types';

type AppApolloClient = ApolloClient<any>;

export async function fetchInterviewChatSummary(
  client: AppApolloClient
): Promise<InterviewChatSummary> {
  const result = await client.query<{
    interviewChatSummary: InterviewChatSummary;
  }>({
    query: GET_INTERVIEW_CHAT_SUMMARY,
    fetchPolicy: 'network-only',
  });

  const summary = result.data?.interviewChatSummary;
  if (!summary) throw new Error('Interview chat summary returned no data.');

  return summary;
}

export async function fetchInterviewForChat(
  client: AppApolloClient,
  interviewId: string
): Promise<InterviewChatInterview | null> {
  const result = await client.query<{
    getInterviews: { entities: InterviewChatInterview[] };
  }>({
    query: GET_INTERVIEW_FOR_CHAT,
    variables: { input: { id: interviewId, limit: 1 } },
    fetchPolicy: 'cache-first',
  });

  return result.data?.getInterviews?.entities?.[0] ?? null;
}
